import {
  Archive,
  ArrowCircleDown,
  ArrowCircleLeft,
  ArrowCircleRight,
  ArrowCircleUp,
  ArrowCounterClockwise,
  ArrowDown,
  ArrowDownRight,
  ArrowLeft,
  ArrowLineLeft,
  ArrowLineRight,
  ArrowLineUpRight,
  ArrowRight,
  ArrowsDownUp,
  ArrowsOutCardinal,
  ArrowSquareIn,
  ArrowSquareOut,
  ArrowsSplit,
  ArrowUp,
  ArrowUUpLeft,
  Article,
  Atom,
  BezierCurve,
  BookOpen,
  BoxArrowDown,
  Broom,
  Calculator,
  CaretCircleDoubleRight,
  CaretDoubleLeft,
  CaretDoubleRight,
  CaretDoubleUp,
  CaretDown,
  CaretLeft,
  CaretLineDown,
  CaretLineUp,
  CaretRight,
  CaretUp,
  ChartBar,
  ChartLine,
  ChartPie,
  ChatText,
  Check,
  CheckCircle,
  CheckSquareOffset,
  Circle,
  CircleNotch,
  ClipboardText,
  Clock,
  ClockCountdown,
  ClockCounterClockwise,
  Code,
  Columns,
  Cookie,
  Copy,
  CopySimple,
  CornersOut,
  CrosshairSimple,
  Cube,
  CursorClick,
  Database,
  DotsThree,
  DotsThreeVertical,
  DownloadSimple,
  Empty,
  Envelope,
  ExclamationMark,
  Export,
  Eye,
  EyeClosed,
  Eyeglasses,
  EyeSlash,
  Factory,
  FileArrowDown,
  FileArrowUp,
  FileAudio,
  FileCode,
  FileCsv,
  FileDoc,
  FileImage,
  FileJpg,
  FileMagnifyingGlass,
  FilePdf,
  FilePng,
  FilePpt,
  Files,
  FileText,
  FileVideo,
  FileX,
  FileXls,
  FileZip,
  FloppyDisk,
  Function,
  Funnel,
  GearFine,
  GearSix,
  GlobeHemisphereWest,
  Hash,
  Headset,
  Hourglass,
  House,
  Info,
  Key,
  Lifebuoy,
  Lightbulb,
  Link,
  LinkBreak,
  LinkSimple,
  LinkSimpleBreak,
  ListChecks,
  Lock,
  LockOpen,
  LockSimple,
  LockSimpleOpen,
  MagnifyingGlass,
  MapPin,
  MapTrifold,
  Megaphone,
  Microscope,
  Minus,
  MinusCircle,
  Monitor,
  NotePencil,
  Package,
  Palette,
  Paperclip,
  PaperPlaneTilt,
  PencilSimple,
  Placeholder,
  Play,
  PlayCircle,
  Plug,
  PlugsConnected,
  Plus,
  PlusCircle,
  Power,
  PresentationChart,
  Prohibit,
  PushPinSimple,
  PushPinSimpleSlash,
  Question,
  Scales,
  SealCheck,
  Share,
  ShieldCheck,
  SignIn,
  SignOut,
  SmileySad,
  SortAscending,
  SortDescending,
  Sparkle,
  Spinner,
  SpinnerGap,
  SquaresFour,
  Stack,
  Swap,
  Tag,
  TestTubeIcon,
  TextIndent,
  Toolbox,
  Trash,
  TrayArrowDown,
  TrayArrowUp,
  TreeStructure,
  Upload,
  UploadSimple,
  User,
  UserCircleGear,
  UserMinus,
  UserPlus,
  Users,
  UsersThree,
  Warning,
  WarningCircle,
  WarningOctagon,
  Wrench,
  X,
  XCircle,
  CpuIcon,
} from "@phosphor-icons/react";
import {
  Building,
  ChatCheckIcon,
  ClipboardCheckIcon,
  ClipboardPlusIcon,
  CommentPlusIcon,
  CustomCSVFile,
  CustomDOCFile,
  CustomDOCXFile,
  CustomFile,
  CustomJPEGFile,
  CustomPDFFile,
  CustomPNGFile,
  CustomXLSFile,
  CustomXLSXFile,
  EnvelopePresentation,
  FileLockSimple,
  FilePlayIcon,
  FileUnlockSimple,
  LineHorizontalOne,
  LinesHorizontalFour,
  LinesHorizontalThree,
  LinesHorizontalTwo,
  PlusClockCounterClockwiseOffsetIcon,
  PlusClockOffsetIcon,
  PresentationLockSimpleIcon,
  PresentationPlusIcon,
  PresentationUnlockSimpleIcon,
  SealQuestion,
  Sigma,
  TriangleDown,
  ValidereIcon,
} from "./CustomIcons";

export const IconMapping = {
  atom: Atom,
  "minus-circle": MinusCircle,
  "arrow-counter-clockwise": ArrowCounterClockwise,
  "arrow-square-out": ArrowSquareOut,
  "arrow-square-in": ArrowSquareIn,
  "arrows-down-up": ArrowsDownUp,
  stack: Stack,
  "play-circle": PlayCircle,
  "note-pencil": NotePencil,
  "caret-circle-double-right": CaretCircleDoubleRight,
  question: Question,
  "check-circle": CheckCircle,
  clock: Clock,
  plus: Plus,
  "plus-circle": PlusCircle,
  "pencil-simple": PencilSimple,
  download: DownloadSimple,
  share: Share,
  trash: Trash,
  "play-simple": Play,
  "download-simple": DownloadSimple,
  x: X,
  "crosshair-simple": CrosshairSimple,
  "caret-up": CaretUp,
  "caret-down": CaretDown,
  "caret-right": CaretRight,
  "caret-left": CaretLeft,
  "caret-double-right": CaretDoubleRight,
  "caret-double-left": CaretDoubleLeft,
  "caret-double-up": CaretDoubleUp,
  "chart-bar": ChartBar,
  "tree-structure": TreeStructure,
  "globe-hemisphere-west": GlobeHemisphereWest,
  "clipboard-text": ClipboardText,
  warning: Warning,
  "warning-circle": WarningCircle,
  "warning-octagon": WarningOctagon,
  article: Article,
  database: Database,
  "gear-six": GearSix,
  "chart-pie": ChartPie,
  "clock-counter-clockwise": ClockCounterClockwise,
  scales: Scales,
  home: House,
  swap: Swap,
  wrench: Wrench,
  "circle-notch": CircleNotch,
  spinner: Spinner,
  "spinner-gap": SpinnerGap,
  info: Info,
  lightbulb: Lightbulb,
  lock: Lock,
  "lock-open": LockOpen,
  "lock-simple": LockSimple,
  "lock-simple-open": LockSimpleOpen,
  "smiley-sad": SmileySad,
  "list-checks": ListChecks,
  "x-circle": XCircle,
  "user-circle-gear": UserCircleGear,
  "dots-three-vertical": DotsThreeVertical,
  "dots-three": DotsThree,
  archive: Archive,
  "box-arrow-down": BoxArrowDown,
  "tray-arrow-down": TrayArrowDown,
  "tray-arrow-up": TrayArrowUp,
  copy: Copy,
  "copy-simple": CopySimple,
  upload: Upload,
  "upload-simple": UploadSimple,
  "line-horizontal-one": LineHorizontalOne,
  "lines-horizontal-two": LinesHorizontalTwo,
  "lines-horizontal-three": LinesHorizontalThree,
  "lines-horizontal-four": LinesHorizontalFour,
  "magnifying-glass": MagnifyingGlass,
  "push-pin-simple": PushPinSimple,
  "push-pin-simple-slash": PushPinSimpleSlash,
  "presentation-chart": PresentationChart,
  "arrow-circle-up": ArrowCircleUp,
  "arrow-circle-down": ArrowCircleDown,
  "arrow-circle-left": ArrowCircleLeft,
  "arrow-circle-right": ArrowCircleRight,
  columns: Columns,
  calculator: Calculator,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "file-x": FileX,
  "arrow-line-up-right": ArrowLineUpRight,
  users: Users,
  "users-three": UsersThree,
  "shield-check": ShieldCheck,
  "seal-check": SealCheck,
  "sign-in": SignIn,
  "sign-out": SignOut,
  lifebuoy: Lifebuoy,
  headset: Headset,
  code: Code,
  package: Package,
  "file-text": FileText,
  "file-pdf": FilePdf,
  "file-csv": FileCsv,
  "file-xls": FileXls,
  "file-zip": FileZip,
  tag: Tag,
  monitor: Monitor,
  hourglass: Hourglass,
  circle: Circle,
  eye: Eye,
  "map-pin": MapPin,
  "chart-line": ChartLine,
  eyeglasses: Eyeglasses,
  export: Export,
  "file-arrow-down": FileArrowDown,
  "file-arrow-up": FileArrowUp,
  link: Link,
  "link-break": LinkBreak,
  "link-simple": LinkSimple,
  "link-simple-break": LinkSimpleBreak,
  "file-png": FilePng,
  "file-jpg": FileJpg,
  "file-image": FileImage,
  funnel: Funnel,
  "floppy-disk": FloppyDisk,
  placeholder: Placeholder,
  hash: Hash,
  "sigma-icon": Sigma,
  "seal-question": SealQuestion,
  files: Files,
  "triangle-down": TriangleDown,
  prohibit: Prohibit,
  "book-open": BookOpen,
  "bezier-curve": BezierCurve,
  sparkle: Sparkle,
  building: Building,
  validere: ValidereIcon,
  "check-square-offset": CheckSquareOffset,
  "sort-descending": SortAscending,
  "sort-ascending": SortDescending,
  "eye-closed": EyeClosed,
  "map-trifold": MapTrifold,
  "file-magnifying-glass": FileMagnifyingGlass,
  "custom-xlsx-file": CustomXLSXFile,
  "custom-xls-file": CustomXLSFile,
  "custom-docx-file": CustomDOCXFile,
  "custom-doc-file": CustomDOCFile,
  "custom-csv-file": CustomCSVFile,
  "custom-png-file": CustomPNGFile,
  "custom-jpeg-file": CustomJPEGFile,
  "custom-pdf-file": CustomPDFFile,
  "custom-file": CustomFile,
  "chat-text": ChatText,
  paperclip: Paperclip,
  "paper-plane-tilt": PaperPlaneTilt,
  cookie: Cookie,
  power: Power,
  "chat-check": ChatCheckIcon,
  "plus-clock-counter-clockwise-offset": PlusClockCounterClockwiseOffsetIcon,
  "clipboard-plus": ClipboardPlusIcon,
  "presentation-plus": PresentationPlusIcon,
  "clipboard-check": ClipboardCheckIcon,
  "file-play": FilePlayIcon,
  megaphone: Megaphone,
  "comment-plus": CommentPlusIcon,
  "corners-out": CornersOut,
  "squares-four": SquaresFour,
  "clock-countdown": ClockCountdown,
  cube: Cube,
  "plus-clock-offset": PlusClockOffsetIcon,
  "file-lock-simple": FileLockSimple,
  "file-unlock-simple": FileUnlockSimple,
  "presentation-lock-simple": PresentationLockSimpleIcon,
  "presentation-unlock-simple": PresentationUnlockSimpleIcon,
  factory: Factory,
  "gear-fine": GearFine,
  plug: Plug,
  "plugs-connected": PlugsConnected,
  "eye-slash": EyeSlash,
  "file-ppt": FilePpt,
  "file-code": FileCode,
  "file-audio": FileAudio,
  "file-video": FileVideo,
  "file-doc": FileDoc,
  empty: Empty,
  user: User,
  "arrow-down-right": ArrowDownRight,
  "arrow-down": ArrowDown,
  "arrow-up": ArrowUp,
  check: Check,
  palette: Palette,
  "arrow-u-up-left": ArrowUUpLeft,
  "exclamation-mark": ExclamationMark,
  "user-minus": UserMinus,
  "user-plus": UserPlus,
  key: Key,
  "arrow-line-left": ArrowLineLeft,
  "arrow-line-right": ArrowLineRight,
  toolbox: Toolbox,
  microscope: Microscope,
  "cursor-click": CursorClick,
  envelope: Envelope,
  "envelope-presentation": EnvelopePresentation,
  "arrows-split": ArrowsSplit,
  "text-indent": TextIndent,
  broom: Broom,
  minus: Minus,
  "arrows-out-cardinal": ArrowsOutCardinal,
  "caret-line-up": CaretLineUp,
  "caret-line-down": CaretLineDown,
  function: Function,
  "test-tube": TestTubeIcon,
  cpu: CpuIcon,
} as const;
